export const PodcastWidgetId = 'PodcastWidget';

export enum PodcastWidgetAttributes {
  TITLE = 'title',
  TITLE_COMPONENT = 'titleComponent',
  TEXT = 'text',
  IMAGE = 'image',
  FILE = 'file',
  THEME = 'theme',
}
